import { type Action, createActionsHook, createStateHook, createStore } from 'react-sweet-state';

type ActiveSpotlightState = {
	activeSpotlight: null | number;
};

const initialState: ActiveSpotlightState = {
	activeSpotlight: null,
};

const actions = {
	start:
		(): Action<ActiveSpotlightState> =>
		({ setState }) => {
			setState({ activeSpotlight: 0 });
		},
	next:
		(): Action<ActiveSpotlightState> =>
		({ setState, getState }) => {
			setState({ activeSpotlight: (getState().activeSpotlight || 0) + 1 });
		},
	end:
		(): Action<ActiveSpotlightState> =>
		({ setState }) => {
			setState({ activeSpotlight: null });
		},
};

const ConversationAssistantSpotlightStore = createStore({
	initialState,
	actions,
	name: 'ConversationAssistantSpotlightStore',
});

export const useConversationAssistantSpotlightActions = createActionsHook(
	ConversationAssistantSpotlightStore,
);
export const useConversationAssistantSpotlightState = createStateHook(
	ConversationAssistantSpotlightStore,
);
